import { useSyncExternalStore } from "react";

export type Language = "uz" | "ru";
type Preferences = { language: Language; theme: "light" | "dark" | "system" };
const KEY = "avtodaftar_mechanic_preferences_v1";
function read(): Preferences {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) ?? "{}");
    return { language: saved.language === "ru" ? "ru" : "uz", theme: ["light", "dark"].includes(saved.theme) ? saved.theme : "system" };
  } catch { return { language: "uz", theme: "system" }; }
}
let value = read();
const listeners = new Set<() => void>();
export function setPreferences(patch: Partial<Preferences>) {
  value = { ...value, ...patch };
  try { localStorage.setItem(KEY, JSON.stringify(value)); } catch { /* Session preference still works. */ }
  listeners.forEach((listener) => listener());
}
export function usePreferences() {
  return useSyncExternalStore((listener) => { listeners.add(listener); return () => { listeners.delete(listener); }; }, () => value);
}
export function locale() { return value.language === "ru" ? "ru-RU" : "uz-UZ"; }
export function t(uz: string, ru?: string) { return value.language === "ru" ? ru ?? translations[uz] ?? uz : uz; }
import { translations } from "./translations";
